import { makeGetRequest } from 'owa-ows-gateway';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { getQueryStringParameter } from 'owa-querystring';
import { GetStartedTaskStatus } from '../enums/GetStartedTaskStatus';

const TaskQueryParamName = 'tasks';
const GET_PENDING_TASKS_URL: string = 'ows/api/v1.0/getstarted/tasks/pending';

export async function getGetStartedTasks(): Promise<any> {
    let taskQueryOverride = getQueryStringParameter(TaskQueryParamName);

    if (taskQueryOverride) {
        return taskQueryOverride.split(',').map(task => {
            return {
                identity: task,
                status: GetStartedTaskStatus.Pending,
                clicked: false,
                hideCompleted: true,
            };
        });
    }

    const response = await makeGetRequest(GET_PENDING_TASKS_URL, undefined, true);

    if (isSuccessStatusCode(response.status)) {
        return response.json();
    }

    return undefined;
}
